const pageBot = {
  robotConfig: {
    preCallSettingTitle: 'Pre-Call Setting',
    preCallSettingDesc: 'Pre-Call Setting',
    speechSettingTitle: 'Speech Setting',
    speechSettingDesc: 'Speech Setting',
    postCallSettingTitle: 'Post-Call Setting',
    postCallSettingDesc: 'Speech Setting',
    preCallSettingFlow: 'Flow',
    preCallSettingVariable: 'Variable'
  }
}

export default pageBot
